import type { Effect, Reducer } from 'umi';

import type { DeliveryBookingDataType } from './data';
import { getDeliveryBookingDetail } from './service';

export interface StateType {
  deliveryBooking?: DeliveryBookingDataType;
}

export interface ModelType {
  namespace: string;
  state: StateType;
  effects: {
    get: Effect;
  };
  reducers: {
    save: Reducer<StateType>;
    clear: Reducer<StateType>;
  };
}

const Model: ModelType = {
  namespace: 'adminBookingModel',
  state: {
    deliveryBooking: undefined,
  },
  effects: {
    *get({ payload }, { call, put }) {
      const response = yield call(getDeliveryBookingDetail, payload);
      yield put({
        type: 'save',
        payload: response.data,
      });
    },
  },

  reducers: {
    save(state, action) {
      return {
        ...state,
        deliveryBooking: action.payload,
      };
    },
    clear() {
      return {
        deliveryBooking: undefined,
      };
    },
  },
};

export default Model;
